export class Checker {
  public static truthy(value: any): boolean {
    if (value === undefined) return false;
    if (value === null) return false;
    if (value === '') return false;
    const t = typeof value;
    switch (t) {
      case 'number':
        if (isNaN(value)) return false;
        break;
      case 'bigint':
      default:
        return true
    }
  }

  public static empty(value: Array<any>): boolean {
    if (!Checker.truthy(value)) return true;
    return value.length === 0;
  }
}
